import { useEffect, useRef } from "react";

const useMounted = (
  effect: React.EffectCallback,
  deps?: React.DependencyList
) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useMounted;
